import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../components/toast/Toast';
import { useUpdateCalculationTemplate } from '../../queries/resources/calculation-templates';

type ArchiveConfirmProps = {
    templateId: string;
    onClose: () => void;
};

function CWTArchive({ templateId, onClose }: ArchiveConfirmProps): JSX.Element {
    const { mutate, isLoading } = useUpdateCalculationTemplate(templateId);

    function handleArchive(): void {
        mutate(
            { status: 'ARCHIVED' },
            {
                onError: (err) => {
                    toastNotification('error', err.response?.data.message ?? 'Something went wrong');
                },
                onSuccess: () => {
                    onClose();
                    toastNotification('success', 'Template archived!');
                },
            }
        );
    }

    return (
        <Dialog
            title="Archive"
            primaryAction="Archive"
            secondaryAction="Cancel"
            description="Archiving this template will make it unavailable to use in workpapers. Worksheets that currently use this template will still be available. You can unarchive this template at any time."
            isOpen
            type="error"
            onClose={onClose}
            onSecondaryActionClick={onClose}
            onPrimaryActionClick={handleArchive}
            isLoading={isLoading}
        />
    );
}

export default CWTArchive;
